import { createSlice } from '@reduxjs/toolkit'

import { Owner, PaymentsState } from '../model/billing.model'

export const paymentsInitialState: PaymentsState = {
  iban: {
    errorMessage: '',
    errorCode: '',
    loading: null,
    isValid: null,
    value: '',
  },
  paymentOwner: {
    owner: Owner.SAME,
    name: '',
    firstName: '',
    lastName: '',
    docId: '',
  },
  address: '',
  contractDestination: undefined,
}

export const paymentsSlice = createSlice({
  name: 'payments',
  initialState: paymentsInitialState,
  reducers: {
    setFields: (state, action) => {
      return {
        ...state,
        paymentOwner: action.payload.paymentOwner || state.paymentOwner,
        address: action.payload.address || state.address,
        contractDestination: action.payload.contractDestination || state.contractDestination,
      }
    },
    setAddress: (state, action) => {
      return {
        ...state,
        address: action.payload,
      }
    },
    setIban: (state, action) => {
      return {
        ...state,
        iban: {
          ...state.iban,
          isValid: action.payload === state.iban.value ? state.iban.isValid : null,
          value: action.payload,
        },
      }
    },
    validateIban: (state, action) => {
      return {
        ...state,
        iban: {
          ...paymentsInitialState.iban,
          loading: true,
          isValid: null,
          value: action.payload,
        },
      }
    },
    validateIbanSuccess: (state, action) => {
      return {
        ...state,
        iban: {
          ...state.iban,
          isValid: action.payload,
          loading: false,
        },
      }
    },
    validateIbanError: (state, action) => {
      return {
        ...state,
        iban: {
          ...state.iban,
          isValid: null,
          loading: false,
          ...action.payload,
        },
      }
    },
  },
})

export const {
  validateIban,
  validateIbanSuccess,
  validateIbanError,
  setIban,
  setFields,
} = paymentsSlice.actions

const paymentsReducer = paymentsSlice.reducer

export default paymentsReducer
